import { Heading } from '@aws-amplify/ui-react'
import React from 'react'

export const ResetPasswordHeader = () => {
  return (
    <Heading level={5} fontWeight={600}>
      Reset your password
    </Heading>
  )
}
